var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35B7BA",
    d: "m16.544 8.596l-1.484 1.49a3.603 3.603 0 0 1-4.974 4.975l-1.49 1.483a5.673 5.673 0 0 0 7.948-7.948m-8.129 3.429a3.603 3.603 0 0 1 5.467-3.092l1.496-1.496a5.673 5.673 0 0 0-7.941 7.942l1.495-1.49a3.6 3.6 0 0 1-.523-1.864zm9.195-4.389a1.247 1.247 0 1 0 .065-2.493a1.247 1.247 0 0 0-.065 2.493M6.39 18.857a1.248 1.248 0 1 0 .064-2.495a1.248 1.248 0 0 0-.064 2.495"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcx);
export default __webpack_public_path__ + "static/media/icx.122602829ca13375788530752ce2c3da.svg";
export { ForwardRef as ReactComponent };